import {
  darkMapStyle,
  lightMapStyle,
} from "@/components/molecules/Map/PenPortraitMap/config";
import React, {useCallback, useEffect, useState} from "react";

import Map, { Source, Layer } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";

import { areaBaseLayer } from "./MapLayers";
import { default as PenPortraitOverlay } from "./PenPortraitOverlay";

import { InsightResult } from "@/types";

type PenPortraitMapProps = {
  areaScores: InsightResult[];
  mapStyle: string;
};

const PenPortraitMap: React.FC<PenPortraitMapProps> = ({
  areaScores,
  mapStyle,
}) => {
  const MAP_STYLE = mapStyle === "light" ? lightMapStyle : darkMapStyle;
  const [firstTime, setFirstTime] = useState<boolean>(true);

  const onLoad = useCallback((event) => {
    const map = event.target;
    map &&
      areaScores.forEach((value) => {
        map.setFeatureState(
          {
            id: value.tag_id - 113,
            source: "area-source",
            sourceLayer: "areas_output",
          },
          { score: value.score_sum }
        );
      });
  }, []);

  const onClick = useCallback((event) => {
    const feature = event.features && event.features[0];
  }, []);

  const onStyleData = useCallback((event) => {
    setFirstTime(false);
  }, []);

  return (
    <Map
      key={mapStyle}
      initialViewState={{
        longitude: -4.27,
        latitude: 55,
        zoom: 3.8,
      }}
      projection={{ name: "mercator" }}
      minZoom={3.8}
      maxZoom={3.8}
      mapStyle={MAP_STYLE}
      mapboxAccessToken={process.env.REACT_APP_MAPBOX_MAP_TOKEN}
      attributionControl={false}
      onLoad={onLoad}
      onClick={onClick}
      onStyleData={onStyleData}
      interactiveLayerIds={["area-base"]}
      dragPan={false}
      dragRotate={false}
      style={{ borderRadius: "5px" }}
    >
      <Source
        id="area-source"
        type="vector"
        url="mapbox://adamsmithstarcount.1c7qwfks"
      >
        <Layer beforeId="waterway-label" {...areaBaseLayer} />
      </Source>
      <PenPortraitOverlay scores={areaScores} firstTime={firstTime}/>
    </Map>
  );
};

export default PenPortraitMap;
